import { msAPI, uploadFileToS3, manageAPI } from "./index";


/**
 * Get a presigned URL for CSV upload
 * @returns {Promise<{key: string, presigned_url: string}>}
 */
export async function getFileUploadPresignedUrl(fileType,contentType) {
    const encodedFileType = encodeURIComponent(fileType);
    const encodedContentType = encodeURIComponent(contentType);
    return (await manageAPI.get(`crm/upload-presigned-url`, { params: { file_type: encodedFileType, content_type: encodedContentType } })).data;
  }

  
/**
 * Upload an image to S3 using presigned URL
 * @param {File} file - The file to upload
 * @returns {Promise<string>} - The URL of the uploaded file
 */
export async function uploadImageToS3(file) {
  try {
    // Get presigned URL
    const { key, presigned_url } = await getFileUploadPresignedUrl(
      "image",
      file.type
    );

    // Upload to S3
    await uploadFileToS3(presigned_url, file, file.type);
    return "https://cdn.saucey.com/"+key;
  } catch (error) {
    throw error;
  }
}

/**
 * Upload a product document to S3 using presigned URL
 * @param {File} file - The file to upload
 * @returns {Promise<string>} - The URL of the uploaded file
 */
export async function uploadProductDocumentToS3(file) {
  try {
    // Get presigned URL for product documents
    const { key, presigned_url } = await getFileUploadPresignedUrl(
      "product_document",
      file.type
    );

    // Upload to S3
    await uploadFileToS3(presigned_url, file, file.type);
    return "https://cdn.saucey.com/"+key;
  } catch (error) {
    throw error;
  }
}

/**
 * Upload a product image override to S3 using presigned URL
 * @param {File} file - The file to upload
 * @returns {Promise<{url: string, key: string, bucket: string}>} - The URL, key, and bucket of the uploaded file
 */
export async function uploadProductImageToS3(file) {
  try {
    // Get presigned URL for product image overrides
    const { key, presigned_url, bucket } = await getFileUploadPresignedUrl(
      "product_image",
      file.type
    );

    // Upload to S3
    await uploadFileToS3(presigned_url, file, file.type);
    return {
      url: "https://cdn.saucey.com/"+key,
      key: key,
      bucket: bucket
    };
  } catch (error) {
    throw error;
  }
}

/**
 * Get a presigned URL for business document upload
 * @param {string} contentType - The content type of the file
 * @returns {Promise<{key: string, presigned_url: string}>}
 */
export async function getBusinessDocumentPresignedUrl(contentType) {
  const encodedContentType = encodeURIComponent(contentType);
  return (await manageAPI.get(`upload-business-document-url?file_type=business_document&content_type=${encodedContentType}`)).data;
}

/**
 * Upload a business document to S3 using presigned URL
 * @param {File} file - The file to upload
 * @returns {Promise<string>} - The URL of the uploaded file
 */
export async function uploadBusinessDocumentToS3(file) {
  try {
    // Get presigned URL for business documents
    const { key, presigned_url } = await getBusinessDocumentPresignedUrl(file.type);

    // Upload to S3
    await uploadFileToS3(presigned_url, file, file.type);
    return key;
  } catch (error) {
    throw error;
  }
}
